import React from 'react';
import { CircularProgress, Typography, Box, Collapse, IconButton } from '@mui/material';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { postApi } from "../../../utils/apiFunction";
import TextField from '@mui/material/TextField';
import { useJumboTheme } from "@jumbo/hooks";
import getCreditMemoData from '../Function/GetCreditMemoStock';
import Button from '@mui/material/Button';
import GetPreview from '../Function/GetPreview';

const SOPreview = (props) => {
    const { theme } = useJumboTheme();
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({}); // initialize as object
    const [localReload, setLocalReload] = React.useState(false);

    React.useEffect(() => {
        const abortController = new AbortController();
        setData({});
        console.log('Fetching preview data for id:' + props.id);
        GetPreview(props.id, abortController, setLoading, setData);
        return () => abortController.abort();
    }, [props.id]);

    const cellStyle = {
        fontSize: '12px',
        paddingTop: '3px',
        paddingBottom: '3px',
        whiteSpace: 'nowrap',
        maxWidth: '150px',
        overflow: 'hidden'
    };

    // Hide everything if id is null/undefined
    if (!props.id) {
        return null;
    } else {
        return (
            <React.Fragment>
                <strong> Sales Order/Shipment Preview</strong><br />
                <span style={{ paddingTop: '15px', paddingBottom: '15px', display: 'block' }}>
                    {data?.myobid ?? ''} - {data?.customer ?? ''}<br />
                    Shipment Date: {data?.shipmentDate ?? ''}<br />
                    Description: {data?.description ?? ''}<br />
                </span>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell style={cellStyle} width="20%">Stock Item</TableCell>
                            <TableCell style={cellStyle} width="20%">Lot Serial Nbr.</TableCell>
                            <TableCell style={cellStyle} width="20%">Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(data?.lines) && data.lines.length > 0 ? (
                            data.lines.map((ln, idx) => (
                                <TableRow key={ln?.id ?? idx}>
                                    <TableCell style={cellStyle}>{ln?.stockItem}</TableCell>
                                    <TableCell style={cellStyle}>{ln?.lotSerialNbr}</TableCell>
                                    <TableCell style={cellStyle}>{ln?.quantity ?? 0}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <Typography variant="body2" color="text.secondary">
                                        No lines found.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </React.Fragment>
        );
    }
}

export default SOPreview;
